/* eslint-disable no-undef */
function d(publishSource) {
  var d = $.trim($('#searchText').val());
  var isShow = $('#searchText').css('display');
  if (isShow === 'none') {
    d = $('.mySwiperWord .swiper-wrapper .swiper-slide-active').text();
  }
  var url = '';
  if (window.darkCrinklesWords) {
    for (var i = 0; i < window.darkCrinklesWords.length; i++) {
      if (
        d === window.darkCrinklesWords[i].title &&
        window.darkCrinklesWords[i].url
      ) {
        url = window.darkCrinklesWords[i].url;
        break;
      }
    }
  }
  if (url) {
    window.open(url);
  } else {
    var pmSearchUrl = '//pmsearch.jd.com/';
    var projectType = getQueryStringByAllSearchPc('projectType');
    if (publishSource > 0) {
      pmSearchUrl =
        pmSearchUrl +
        '?publishSource=' +
        publishSource +
        '&projectType=' +
        projectType +
        '&searchParam=' +
        d;
    }
    window.open(pmSearchUrl);
  }
}
function getDarkCrinklesWordBySearch() {
  var apiHost = '//api.m.jd.com/api';
  var areaId = '';
  var e = window.pageConfig.headerId;
  if (e === 'bankrupt') {
    areaId = 4600004;
  } else if (e === 'zichan') {
    areaId = 4600003;
  } else if (e === 'haiguan') {
    areaId = 4600002;
  } else if (e === 'sifa' || e === 'fuwu') {
    areaId = 4600001;
  }
  if (!areaId) {
    $('.mySwiperWord').hide();
    $('#searchText').show();
    return;
  }
  jQuery.ajax({
    url:
      apiHost +
      '?appid=paimai&functionId=gePublicSearchResData&body={areaId:' +
      areaId +
      '}',
    dataType: 'jsonp',
    jsonp: 'jsonp',
    success: function success(res) {
      var swiperWordList = [];
      if (res && res.data && res.data.length > 0) {
        window.darkCrinklesWords = res.data;
        swiperWordList = res.data;
        if (swiperWordList.length > 5) {
          swiperWordList = swiperWordList.slice(0, 5);
        }
        var keyword = getQueryStringByAllSearchPc('searchParam');
        if (keyword) {
          $('#searchText').val(keyword);
          if (swiperWordList && swiperWordList.length > 1) {
            var isInDarkCrinklesWords = false;
            for (var i = 0; i < swiperWordList.length; i++) {
              if (swiperWordList[i].title === keyword) {
                isInDarkCrinklesWords = true;
                var swiperSlide = '';
                for (var x = 0; x < swiperWordList.length; x++) {
                  swiperSlide =
                    swiperSlide +
                    '<div class="swiper-slide swiper-no-swiping">' +
                    swiperWordList[x].title +
                    '</div>';
                }
                $('.mySwiperWord .swiper-wrapper').html(swiperSlide);
                window.swiperSwiperWords = new Swiper('.mySwiperWord', {
                  autoplay: true,
                  loop: true,
                  initialSlide: i,
                  direction: 'vertical'
                });
                break;
              }
            }
            if (isInDarkCrinklesWords) {
              $('.mySwiperWord').show();
              $('#searchText').hide();
            } else {
              $('.mySwiperWord').hide();
              $('#searchText').show();
            }
          } else {
            $('.mySwiperWord').hide();
            $('#searchText').show();
          }
        } else {
          var darkCrinklesWord = res.data[0];
          $('#searchText').val(darkCrinklesWord.title);
          if (window.location.href.indexOf('fzfw') > -1) {
            $('.mySwiperWord').hide();
            $('#searchText').show();
            return;
          }
          if (swiperWordList && swiperWordList.length > 1) {
            var swiperSlide = '';
            for (var i = 0; i < swiperWordList.length; i++) {
              swiperSlide =
                swiperSlide +
                '<div class="swiper-slide swiper-no-swiping">' +
                res.data[i].title +
                '</div>';
            }
            $('.mySwiperWord .swiper-wrapper').html(swiperSlide);
            window.swiperSwiperWords = new Swiper('.mySwiperWord', {
              autoplay: true,
              loop: true,
              direction: 'vertical'
            });
          } else {
            $('.mySwiperWord').hide();
            $('#searchText').show();
          }
        }
        $('.mySwiperWord .swiper-wrapper .swiper-slide')
          .unbind('click')
          .bind('click', function () {
            var txt = $(this).text();
            window.swiperSwiperWords.autoplay.stop();
            $('.mySwiperWord').hide();
            $('#searchText').show().focus().val(txt);
          });
      } else {
        $('.mySwiperWord').hide();
        $('#searchText').show();
      }
    },
    error: function error() {
      $('.mySwiperWord').hide();
      $('#searchText').show();
    }
  });
}
function getQueryStringByAllSearchPc(name) {
  var replace = true;
  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
  };
  function replaceChar(string) {
    return String(string).replace(/[&<>"'/]/g, function (s) {
      return entityMap[s];
    });
  }
  var reg,
    group,
    arr = [];
  if (name) {
    reg = new RegExp('(\\?|&)' + name + '=([^&]*)', 'g');
    group = window.location.search.match(reg);
  }
  if (group) {
    for (var i = 0; i < group.length; i++) {
      var idx = group[i].indexOf('='),
        value = group[i].substr(idx + 1);
      if (value) {
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          value = '';
        }
        arr.push(replace ? replaceChar(value) : value);
      }
    }
  }
  return arr && arr.length > 0 ? arr[0] : '';
}

export const initHeaderSearch = (publishSource) => {
  getDarkCrinklesWordBySearch();
  var keyword = getQueryStringByAllSearchPc('searchParam');
  $('#searchText').attr('placeholder', $('#searchText').val());
  $('#searchText').val('');
  if (keyword) {
    $('#searchText').val(keyword);
  }
  var a = $('#searchText');
  var b = jQuery.trim(a.val());
  a
    .bind('focus', function () {
      $('#auction-search').addClass('focus');
      b = jQuery.trim(a.val());
      if (!window.darkCrinklesWords || window.darkCrinklesWords.length === 0) {
        this.value = '';
      }
    })
    .bind('blur', function () {
      $('#auction-search').removeClass('focus');
      '' === this.value && (this.value = b);
      if (window.darkCrinklesWords && window.darkCrinklesWords.length > 0) {
        for (var i = 0; i < window.darkCrinklesWords.length; i++) {
          if (window.darkCrinklesWords[i].title === this.value && i < 5) {
            window.swiperSwiperWords.autoplay.start();
            $('.mySwiperWord').show();
            $('#searchText').hide();
            break;
          }
        }
      }
    })
    .bind('keydown', function (event) {
      13 == event.which && d(publishSource);
    });
    $('#searchButton').bind('click', function () {
      d(publishSource);
    });
};
